import { Timestamp } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { Router, CanActivate } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // user;
  // userData;
  // constructor(private af: AngularFireAuth, private db: AngularFirestore, private router: Router) {
  //   af.authState.subscribe((auth) => {
  //     if (auth == null) {
  //       this.router.navigate(['']);
  //       // this.router.navigate(['/login']);
  //     } else {
  //       this.user = auth;
  //       this.getUserData();
  //       this.router.navigate(['']);
  //     }
  //   });
  // }

  // canActivate(): boolean {
  //   return true;
  // }

  // doGoogleLogin() {
  //   return new Promise<any>((resolve, reject) => {
  //     const provider = new firebase.auth.GoogleAuthProvider();
  //     provider.addScope('profile');
  //     provider.addScope('email');
  //     this.af.auth
  //       .signInWithPopup(provider)
  //       .then(res => {
  //         if (res.user != null) {
  //           this.user = res.user;
  //           this.getUserData();
  //           this.router.navigate(['']);
  //         }
  //         resolve(res);
  //       });
  //   });
  // }

  // getUserData() {
  //   this.db.collection('users').doc(this.user.uid).get().subscribe(doc => {
  //     if (doc.exists) {
  //       console.log('exists');
  //     } else {
  //       this.db.collection('users').doc(this.user.uid).set({
  //         w: 0,
  //         name: this.user.displayName,
  //         email: this.user.email,
  //         userName: 'Not Set',
  //         phoneNumber: 0,
  //         profileImage: 'https://via.placeholder.com/150',
  //         gender: 'Male',
  //         score: 0,
  //         winFirstCount: 0,
  //         winSecondCount: 0,
  //         winThirdCount: 0,
  //         created: firebase.firestore.Timestamp.fromDate(new Date())
  //       });
  //       console.log('creating details');

  //     }

  //   });
  // }

  // getuserDetails() {
  //   return this.db.collection('users').doc(this.user.uid);
  // }

}
